module.exports = __webpack_public_path__ + "static/media/load-blue-bg-top.72e3d000.png";